/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_View_Toggle_Aria_LabelInputs */

const en_speakers_view_toggle_aria_label = /** @type {(inputs: Speakers_View_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View toggle`)
};

const fr_speakers_view_toggle_aria_label = /** @type {(inputs: Speakers_View_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer la vue`)
};

const de_speakers_view_toggle_aria_label = /** @type {(inputs: Speakers_View_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansicht umschalten`)
};

const it_speakers_view_toggle_aria_label = /** @type {(inputs: Speakers_View_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza interruttore`)
};

const ru_speakers_view_toggle_aria_label = /** @type {(inputs: Speakers_View_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить вид`)
};

const es_speakers_view_toggle_aria_label = /** @type {(inputs: Speakers_View_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver alternar`)
};

const zh_cn2_speakers_view_toggle_aria_label = /** @type {(inputs: Speakers_View_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看切换`)
};

const ja_speakers_view_toggle_aria_label = /** @type {(inputs: Speakers_View_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示切り替え`)
};

const hi_speakers_view_toggle_aria_label = /** @type {(inputs: Speakers_View_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दृश्य टॉगल`)
};

const pt_pt2_speakers_view_toggle_aria_label = /** @type {(inputs: Speakers_View_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar visualização`)
};

/**
* | output |
* | --- |
* | "View toggle" |
*
* @param {Speakers_View_Toggle_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_view_toggle_aria_label = /** @type {((inputs?: Speakers_View_Toggle_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_View_Toggle_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_view_toggle_aria_label(inputs)
	if (locale === "de") return de_speakers_view_toggle_aria_label(inputs)
	if (locale === "it") return it_speakers_view_toggle_aria_label(inputs)
	if (locale === "ru") return ru_speakers_view_toggle_aria_label(inputs)
	if (locale === "es") return es_speakers_view_toggle_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_view_toggle_aria_label(inputs)
	if (locale === "ja") return ja_speakers_view_toggle_aria_label(inputs)
	if (locale === "hi") return hi_speakers_view_toggle_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_view_toggle_aria_label(inputs)
	return en_speakers_view_toggle_aria_label(inputs)
});